import { FlightDetailModalState, GalleryModalState, InternalChatState, ReelsModalState, TripPlannerState } from 'types';
import { Fragment, h } from '@stencil/core';
import FeedbackModal from './FeedbackModal';
import FeedbackFormModal from './FeedbackFormModal';
import DistributionModal from './DistributionModal';
import VideoPlayerModal from './VideoPlayerModal';
import TermsAndConditionsModal from './TermsAndConditionsModal';
import ViewMoreModal from './ViewMoreModal';
import RecoverChatModal from './RecoverChatModal';
import GalleryModal from './GalleryModal';
import DebugModal from './DebugModal';
import FlightDetailModal from './FlightDetailModal';
import ReschedulingModal from './ReschedulingModal';
import EditTextModal from './EditTextModal';
import ItineraryMapModal from './ItineraryMapModal';
import TripItemDetail from './TripItemDetail';
import CDCModal from './CDCModal';
import VoiceModal from './VoiceModal';

interface ModalsProps {
  store: InternalChatState;
  reelsModal: ReelsModalState;
  galleryModal: GalleryModalState;
  flightDetailModal: FlightDetailModalState;
  tripPlanner: TripPlannerState;
  termsAndConditions: boolean;
}

export default function Modals({ reelsModal, termsAndConditions, store, galleryModal, flightDetailModal, tripPlanner }: ModalsProps) {
  return (
    <Fragment>
      <FeedbackModal show={store.showFullScreenModal === 'FEEDBACK'} />
      <DebugModal show={store.showFullScreenModal === 'DEBUG'} />
      <FeedbackFormModal show={store.showFullScreenModal === 'FEEDBACK_FORM'} />
      <DistributionModal show={store.showFullScreenModal === 'DISTRIBUTION'} />
      <VideoPlayerModal show={reelsModal.isOpen} />
      <TermsAndConditionsModal show={termsAndConditions} />
      <ReschedulingModal show={store.showFullScreenModal === 'RESCHEDULING'} />
      <ViewMoreModal show={store.showFullScreenModal === 'FAQS_VIEW_MORE'} />
      <RecoverChatModal show={store.showFullScreenModal === 'RECOVER_CHAT'} />
      <VoiceModal show={store.showFullScreenModal === 'VOICE'} />
      <GalleryModal show={galleryModal.isOpen} />
      <FlightDetailModal show={flightDetailModal.isOpen} />
      <EditTextModal show={tripPlanner.showModal === 'EDIT_MODAL'} />
      <ItineraryMapModal show={tripPlanner.showModal === 'ITINERARY_MAP_MODAL'} />
      <TripItemDetail show={tripPlanner.showModal === 'ITEM_DETAIL_MODAL'} />
      <CDCModal show={store.showFullScreenModal === 'CONTACT_CENTER'} />
    </Fragment>
  );
}
